import Form from 'react-bootstrap/Form';

function ConsumersStatusFilterForm({ statusFilter, changeStatusFilter, spinner }) {
  return (
    <Form.Select
      className="bo-filter"
      name="statusFilter"
      id="statusFilter"
      disabled={spinner}
      value={statusFilter}
      onChange={e => changeStatusFilter('consumers', e.target.value)}
    >
      <option value="">All Statuses</option>
      <option value="ACTIVE">Active</option>
      <option value="SUSPENDED">Suspended</option>
      <option value="TERMINATED">Terminated</option>
    </Form.Select>
  );
}

export default ConsumersStatusFilterForm;
